import type { AppLocale, LocaleDirection } from './types';

export type LocaleOption = {
  key: AppLocale;
  emoji: string;
  label: string;
  dayjsLocale: string;
  direction: LocaleDirection;
};

export const defaultLocale: AppLocale = 'zh-CN';

export const localeOptions: LocaleOption[] = [
  {
    key: 'bn-BD',
    emoji: '🇧🇩',
    label: 'বাংলা',
    dayjsLocale: 'bn',
    direction: 'ltr',
  },
  {
    key: 'en-US',
    emoji: '🇺🇸',
    label: 'English',
    dayjsLocale: 'en',
    direction: 'ltr',
  },
  {
    key: 'fa-IR',
    emoji: '🇮🇷',
    label: 'فارسی',
    dayjsLocale: 'fa',
    direction: 'ltr',
  },
  {
    key: 'id-ID',
    emoji: '🇮🇩',
    label: 'Bahasa Indonesia',
    dayjsLocale: 'id',
    direction: 'ltr',
  },
  {
    key: 'ja-JP',
    emoji: '🇯🇵',
    label: '日本語',
    dayjsLocale: 'ja',
    direction: 'ltr',
  },
  {
    key: 'pt-BR',
    emoji: '🇧🇷',
    label: 'Português',
    dayjsLocale: 'pt-br',
    direction: 'ltr',
  },
  {
    key: 'zh-CN',
    emoji: '🇨🇳',
    label: '简体中文',
    dayjsLocale: 'zh-cn',
    direction: 'ltr',
  },
  {
    key: 'zh-TW',
    emoji: '🇭🇰',
    label: '繁體中文',
    dayjsLocale: 'zh-tw',
    direction: 'ltr',
  },
];

const localeKeys = new Set<AppLocale>(localeOptions.map(({ key }) => key));

export function isAppLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && localeKeys.has(value as AppLocale);
}

export function resolveLocale(language?: string): AppLocale {
  if (isAppLocale(language)) {
    return language;
  }

  const normalized = language?.toLowerCase();
  const match = localeOptions.find(({ key }) =>
    normalized?.startsWith(key.split('-')[0].toLowerCase()),
  );

  return match?.key ?? defaultLocale;
}

export function getLocaleOption(locale: AppLocale | 'en') {
  // 在上游国际化入口兼容本地保存的英文值，不重写用户偏好。
  const key = locale === 'en' ? 'en-US' : locale;
  return localeOptions.find((option) => option.key === key) ?? localeOptions[6];
}
